import styled from "styled-components";
import { FLEX } from "../../../styles/flex";
import * as mediaQuery from "components/MediaQuery";
import { calcRem } from "styles/theme";
import { InnerPaddingWrapper } from "components/atoms/inner/InnerContainer";

export const SubHeader = styled(InnerPaddingWrapper)`
  width: 100%;
  padding-top: 30px;
  padding-bottom: 5px;
`;

export const HeaderContainer = styled.div`
  min-height: 55px;
  ${mediaQuery.isDefault} {
    ${FLEX.FlexBetweenCenter};
    gap: 20px;
    padding: 8px 0;
  }
  ${mediaQuery.isMobile} {
    min-height: auto;
    ${FLEX.FlexStartStart};
    flex-direction: column;
    gap: 10px;
  }
  ${mediaQuery.isTablet} {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }
  .storage-label-mobile {
    width: 400px;
    max-width: calc(100vw - 26px);
  }
  .storage-label-default {
    min-width: 400px;
  }
`;

export const TopWrapper = styled.div`
  ${FLEX.FlexBetweenCenter};
`;

export const Title = styled.div`
  ${mediaQuery.isMobile} {
    span {
      display: inline-block;
      line-height: 1.2;
      overflow-x: hidden;
      overflow-y: visible;
    }
  }
`;

export const TitleLeft = styled.div`
  ${FLEX.FlexStartCenter};
  align-items: baseline;
  gap: 50px;
  ${mediaQuery.isDefault} {
    flex: 1;
  }
  ${mediaQuery.isTablet} {
    gap: 10px;
  }
`;

export const TitleTextWrapper = styled.div`
  ${FLEX.FlexStartStart};
  flex-direction: column;
`;
export const TitleDescription = styled.div`
  ${FLEX.FlexStartCenter};
  gap: 4px;
  font-size: ${calcRem(14)};
  color: ${({ theme }) => theme.COLORS.WHITE}70;
  line-height: 1.25;
  padding-top: 10px;
`;

export const RightAside = styled.ul`
  ${mediaQuery.isDefault} {
    ${FLEX.FlexEndCenter};
    /* max-width: 40%; */
    gap: 8px;
  }
  ${mediaQuery.isMobile} {
    width: 100%;
    ${FLEX.FlexBetweenCenter};
    gap: 7px;
    flex-direction: column;
  }
`;

const CommonRow = `
  ${FLEX.FlexStartCenter};
  gap: 10px;
`;

export const MobileRow = styled.div`
  ${CommonRow};
  width: 100%;
  flex-wrap: wrap;
`;

export const Row = styled.button`
  ${CommonRow};
`;

export const CenterAside = styled.div`
  ${mediaQuery.isDefault} {
    ${FLEX.FlexStartCenter};
    gap: 20px;
    flex: 1 0 auto;
    /* flex: 2;
    padding: 20px 0; */
  }
`;

export const SearchInputWrapper = styled.div`
  ${mediaQuery.isMobile} {
    width: 100%;
    /* max-width: 75%; */
    flex: 6;
  }
  ${mediaQuery.isDefault} {
    max-width: 250px;
  }
`;

export const TitleWrapper = styled.ul`
  max-width: 100%;
  gap: 4px;
  line-clamp: 1;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  > * {
    display: inline;
    word-break: keep-all;
  }
  .chevron-right svg {
    color: ${(props) => props.theme.COLORS.STATUS};
    margin: 0 4px;
  }

  ${mediaQuery.isMobile} {
    flex: 2;
    width: 100%;
    max-width: 90vw;
  }
`;

export const TitleCrumb = styled.li<{ index: number }>`
  font-size: ${calcRem(16)};
  font-weight: normal;
  cursor: pointer;
  color: ${(props) => props.theme.COLORS.STATUS};

  ${({ index, theme }) =>
    index === 0
      ? `
      font-size: ${calcRem(24)};
      color: ${theme.COLORS.WHITE};
  `
      : `
  `}

  &:hover {
    text-decoration: underline;
  }

  ${mediaQuery.isMobile} {
    ${({ index }) =>
      index > 0 &&
      `
      overflow: hidden;
      text-overflow: ellipsis;
    `}
  }
`;

export const FirstTitle = styled.span`
  font-weight: 400;
  font-size: ${calcRem(24)};
  color: ${(props) => props.theme.COLORS.WHITE};
  white-space: nowrap;
`;

export const BigButtonBox = styled.div`
  ${FLEX.FlexEndCenter};
  /* max-width: 160px; */
  flex: 1;

  ${mediaQuery.isMobile} {
    flex-basis: 80px;
  }
`;

export const Back = styled.div`
  ${FLEX.FlexEndCenter};
  /* gap: 6px; */
  cursor: pointer;

  > img {
    width: 5px;
  }
`;
